import s from "./MobileMenu.module.scss";

export const MobileNav = ({ children }) => (
  <nav className={s.mobileNav}>{children}</nav>
);
